// extracted by mini-css-extract-plugin
export default {"ModalTitleLabel":"ModalTitle_ModalTitleLabel__JVRsi","ModalTitleCancel":"ModalTitle_ModalTitleCancel__kTKJ-"};